import PropTypes from "prop-types";

import ActionPopOutOptionWithSubMenu from "@/view/ActionPopOutOptionWithSubMenu";

const propTypes = {
  activeSubMenu: PropTypes.string,
  currentSizeLabel: PropTypes.string,
  dataProps: PropTypes.object,
  disabled: PropTypes.bool,
  eventProperties: PropTypes.object,
  icon: PropTypes.node,
  popOutContents: PropTypes.object,
  setActiveSubMenu: PropTypes.func,
};

const FontSizeMobileAction = ({
  activeSubMenu,
  currentSizeLabel,
  dataProps,
  disabled,
  eventProperties,
  icon,
  popOutContents,
  setActiveSubMenu,
}) => {
  return (
    <ActionPopOutOptionWithSubMenu
      actionName="Size"
      activeSubMenu={activeSubMenu}
      dataProps={dataProps}
      disabled={disabled}
      eventProperties={eventProperties}
      icon={icon}
      popOutContents={popOutContents}
      setActiveSubMenu={setActiveSubMenu}
      title={currentSizeLabel}
    />
  );
};

FontSizeMobileAction.propTypes = propTypes;

export default FontSizeMobileAction;
